import React from 'react';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Center from '../components/Layout/Center';
import { useSelector } from 'react-redux';
import {
  onboardingSearchActivate,
  onboardingSearchCustomize,
  onboardingSearchPreview,
} from '../slices/OnboardingSlice';

import Onboarding from './Onboarding';
import SetupVisualSearch from '../components/SetupVisualSearch/SetupVisualSearch';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function buildCards(history, shopId, t) {
  return [
    {
      id: 'step1',
      header: t('ui.onboardingVisualSearch.safelyPreviewSearch'),
      buttonColor: '#1E2248',
      buttonText: t('onboarding.action.preview'),
      buttonIcon: 'search',
      buttonOnClick: () => {
        const previewWin = window.open('about:blank', '_blank');
        return onboardingSearchPreview(previewWin);
      },
      meta: t('onboarding.search.preview.description'),
    }, {
      id: 'step2',
      header: t('ui.onboardingVisualSearch.customizeSearchAndStyleSettings'),
      buttonColor: '#1E2248',
      buttonText: t('onboarding.action.customize'),
      buttonIcon: 'edit',
      buttonOnClick: () => {
        history.push(`/app/${shopId}/search/settings`);
        return onboardingSearchCustomize();
      },
      meta: t('onboarding.search.customize.description'),
    }, {
      id: 'step3',
      header: t('ui.onboardingVisualSearch.makeSearchEnabledForYourCustomers'),
      buttonColor: 'green',
      buttonText: t('onboarding.action.activate'),
      buttonIcon: 'boat',
      buttonOnClick: () => {
        history.push(`/app/${shopId}/search/dashboard`);
        return onboardingSearchActivate();
      },
      meta: t('onboarding.search.activate.description'),
    },
  ];
}

export default function OnboardingVisualSearch() {
  const history = useHistory();
  const { settings, onboarding } = useSelector((store) => store, undefined);
  const { shopId } = settings;
  const t = useLocalizedMessage();
  const cards = buildCards(history, shopId, t);
  // todo: use visualRecs object here
  if (!onboarding.search.wizardCompleted) {
    return (
      <Grid container justifyContent="center" spacing={4}>
        <Center>
          <SetupVisualSearch />
        </Center>
      </Grid>
    );
  }

  return (
    <Onboarding
      cards={cards}
      header={t('onboarding.visualSearch.title')}
      subheader1={t('onboarding.visualSearch.description')}
      subheader2={t('onboarding.visualSearch.stepsDescription')}
    />
  );
}
